import React from "react";
import { Routes, Route } from "react-router-dom";
import { strings } from "../common/i18n";
import config from "../config";
import Create from "./Create";
import Edit from "./Edit";
import Review from "./Review";
import Closed from "./Status/Closed";
import Scheduled from "./Status/Scheduled";
import Archived from "./Status/Archived";
import NotFound from "../common/components/NotFound";
import Inprogress from "./Status/Inprogress";
import AuditReview from "./Review";
import Draft from "./Status/Draft";

export const routePrefix = `../${config.paths.audits}`;

export const paths = {
    audit: `audit`,
    audits: `/${routePrefix}`,
    scheduled: `scheduled`,
    inprogress: `inprogress`,
    inprogressAudit: `/${routePrefix}/inprogress/:auditId(\\d+)`,
    archived: `archived`,
    draft: `draft`,
    closed: `closed`,
    create: `create`,
    edit: `edit`
};

export const tabsRoutes = [
    {
        component: <Inprogress />,
        key: "inprogress",
        label: strings("inprogress"),
        path: `../${paths.inprogress}`
    },
    {
        component: <Scheduled />,
        key: "scheduled",
        label: strings("scheduled"),
        path: `../${paths.scheduled}`
    },
    {
        component: <Closed />,
        key: "closed",
        label: strings("closed"),
        path: `../${paths.closed}`
    },
    {
        component: <Archived />,
        key: "archived",
        label: strings("archived"),
        path: `../${paths.archived}`
    },
    {
        component: <Draft />,
        key: "draft",
        label: strings("draft"),
        path: `../${paths.draft}`
    }
];
export const createTab = {
    component: <Create />,
    key: "create",
    label: strings("create"),
    path: `../${paths.create}`
};

export default () => (
    <Routes>
        <Route
            path={"/"}
            element={
                <>
                    <Inprogress />
                </>
            }
        />
        <Route path={paths.scheduled} element={<Scheduled />} />
        <Route path={paths.closed} element={<Closed />} />
        <Route path={paths.draft} element={<Draft />} />
        <Route path={paths.inprogress} element={<Inprogress />} />
        <Route path={paths.archived} element={<Archived />} />
        <Route path={paths.create} element={<Create />} />
        <Route path={`/`}>
            <Route path={`:auditId/*`} element={<AuditReview />} />
            {/* <Route path={`:auditId/*`} element={<Review />} /> */}
            <Route
                path={`${paths.edit}/*`}
                errorElement={
                    <NotFound message={strings("messages.auditNotFound")} />
                }
            >
                <Route
                    path=":auditId"
                    element={<Edit />}
                    errorElement={
                        <NotFound message={strings("messages.auditNotFound")} />
                    }
                />
            </Route>
        </Route>
    </Routes>
);
